
import api from "@/api";
import { Station } from "@/api/dtos/Station.schema";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import { User } from "@/api/dtos/User.schema";
import { UsersModule } from "@/store/modules/UsersModule";
import { showToast } from "@/utils/toastService";
import { StationsModule } from "@/store/modules/StationsModule";
import { getAxiosResponse } from "@/utils/errorUtils";

@Component({
  components: {
    EditFrame,
  },
})
export default class StationPlatformService extends Vue {
  @Prop()
  station!: Station;

  platformServiceActive = false;
  private isInitialLoad = true;

  mounted(): void {
    this.platformServiceActive = this.station.platformServiceActive;

    setTimeout(() => {
      this.isInitialLoad = false;
    }, 400);
  }

  get localUser(): User | null {
    return UsersModule.localUser;
  }

  @Watch("platformServiceActive")
  async onPlatformServiceActiveChanged(): Promise<void> {
    try {
      await api.StationsApi.updatePlatformServiceActive(
        this.station.uuid,
        this.platformServiceActive
      );

      await StationsModule.fetchDetailedStation(this.$route.params.stationUuid);

      if (!this.isInitialLoad) {
        showToast({
          message: `Portalservice erfolgreich ${
            this.platformServiceActive ? "aktiviert" : "deaktiviert"
          }`,
          type: "success",
        });
      }
    } catch (e) {
      console.error("Platform service update error:", e);

      if (!this.isInitialLoad) {
        showToast({
          response: getAxiosResponse(e),
          message: `Portalservice konnte nicht ${
            this.platformServiceActive ? "aktiviert" : "deaktiviert"
          } werden`,
          type: "error",
        });
      }
    }
  }
}
